export enum ApplicationsActionType {
  Set = 'applications/SET_APPLICATIONS',
  Get = 'applications/GET_APPLICATIONS',
}
